import { NavLink, useLocation, useHistory } from 'react-router-dom'
import {
  Nav,
  NavList,
  NavItem,
  NavExpandable,
  Page,
  PageHeader,
  PageSidebar,
  SkipToContent,
  PageHeaderTools,
  Icon,
  Tooltip,
  ApplicationLauncher,
  ApplicationLauncherItem,
} from '@patternfly/react-core'
import { routes, IAppRoute, IAppRouteGroup, AppRouteConfig } from '@app/routes/routes'
import * as React from 'react'
import { useKeycloak } from '@react-keycloak/web'
import { ShareSquareIcon } from '@patternfly/react-icons'

// images
import logoWhite from '@app/assets/bgimages/NOIE_LOGO_WHITE.png'
import Aveeno_logo from '@app/assets/bgimages/Aveeno_logo.png'
import Clean_Clear_Logo from '@app/assets/bgimages/Clean_Clear_Logo.png'
import lubriderm_logo from '@app/assets/bgimages/lubriderm_logo.png'
import Neotrata_logo from '@app/assets/bgimages/Neotrata_logo.png'
import Neutrogena_logo from '@app/assets/bgimages/Neutrogena_logo.png'
interface IAppLayout {
  children: React.ReactNode
}

const AppLayout: React.FunctionComponent<IAppLayout> = ({ children }) => {
  const [isNavOpen, setIsNavOpen] = React.useState(true)
  const [isMobileView, setIsMobileView] = React.useState(true)
  const [isNavOpenMobile, setIsNavOpenMobile] = React.useState(false)

  const identity = useKeycloak()

  const onNavToggleMobile = () => {
    setIsNavOpenMobile(!isNavOpenMobile)
  }
  const onNavToggle = () => {
    setIsNavOpen(!isNavOpen)
  }
  const onPageResize = (props: { mobileView: boolean; windowSize: number }) => {
    setIsMobileView(props.mobileView)
  }

  function LogoImg() {
    const history = useHistory()
    const [isOpen, setIsOpen] = React.useState(false)
    const onToggle = (isOpen: boolean) => setIsOpen(isOpen)
    const onSelect = (_event: any) => setIsOpen((prevIsOpen) => !prevIsOpen)

    const appLauncherItems: React.ReactElement[] = [
      <ApplicationLauncherItem key="key_01" component="button" icon={<img src={Aveeno_logo}></img>} onClick={() => alert('Clicked')} style={{ minWidth: '240px' }}>
        Aveeno
      </ApplicationLauncherItem>,
      <ApplicationLauncherItem key="key_02" component="button" icon={<img src={Clean_Clear_Logo}></img>} onClick={() => alert('Clicked')} style={{ minWidth: '240px' }}>
        Clean & Clear
      </ApplicationLauncherItem>,
      <ApplicationLauncherItem key="key_03" component="button" icon={<img src={lubriderm_logo}></img>} onClick={() => alert('Clicked')} style={{ minWidth: '240px' }}>
        Lubriderm
      </ApplicationLauncherItem>,
      <ApplicationLauncherItem key="key_04" component="button" icon={<img src={Neotrata_logo}></img>} onClick={() => alert('Clicked')} style={{ minWidth: '240px' }}>
        Neostrata
      </ApplicationLauncherItem>,
      <ApplicationLauncherItem key="key_05" component="button" icon={<img src={Neutrogena_logo}></img>} onClick={() => alert('Clicked')} style={{ minWidth: '240px' }}>
        Neutrogena
      </ApplicationLauncherItem>,
    ]

    return (
      <React.Fragment>
        <img src={logoWhite} onClick={() => history.push('/')} alt="NØIE" />
        <ApplicationLauncher onSelect={onSelect} onToggle={onToggle} isOpen={isOpen} items={appLauncherItems} removeFindDomNode={true} />
      </React.Fragment>
    )
  }

  const HeaderTools = () => {
    const name = identity.keycloak.tokenParsed ? identity.keycloak.tokenParsed['given_name'] : ''
    const email = identity.keycloak.tokenParsed ? identity.keycloak.tokenParsed['email'] : ''
    const logoutUrl = identity.keycloak.createLogoutUrl({ redirectUri: document.URL })

    return (
      <PageHeaderTools>
        <span className="pf-u-display-inline-block pf-u-pr-md">
          {name} ({email})
        </span>
        <Tooltip content={'Logout'}>
          <a href={logoutUrl}>
            <ShareSquareIcon color="white"></ShareSquareIcon>
          </a>
        </Tooltip>
      </PageHeaderTools>
    )
  }

  const Header = <PageHeader logo={<LogoImg />} headerTools={<HeaderTools />} showNavToggle isNavOpen={isNavOpen} onNavToggle={isMobileView ? onNavToggleMobile : onNavToggle} />

  const location = useLocation()

  const renderNavItem = (route: IAppRoute, index: number) => {
    const userRoles = identity.keycloak.tokenParsed?.realm_access?.roles ?? []
    const role = (route as IAppRoute).role ?? undefined

    if (role && userRoles.includes(role)) {
      return (
        <NavItem key={`${route.label}-${index}`} id={`${route.label}-${index}`} isActive={route.path === location.pathname}>
          <NavLink exact={route.exact} to={route.path}>
            {route.label}
          </NavLink>
        </NavItem>
      )
    } else {
      return <React.Fragment key={`${route.label}-${index}`}></React.Fragment>
    }
  }

  const renderNavGroup = (group: IAppRouteGroup, groupIndex: number) => {
    const userRoles = identity.keycloak.tokenParsed?.realm_access?.roles ?? []
    const groupRoles = group.routes.filter((p) => typeof p.role === 'string').map((p) => p.role)
    let shouldRenderGroup = false

    for (const userRole of userRoles) {
      if (groupRoles.includes(userRole)) {
        shouldRenderGroup = true
      }
    }

    if (shouldRenderGroup) {
      return (
        <NavExpandable
          key={`${group.label}-${groupIndex}`}
          id={`${group.label}-${groupIndex}`}
          title={group.label}
          isActive={group.routes.some((route) => route.path === location.pathname)}
          isExpanded={group.routes.some((route) => route.path === location.pathname)}
        >
          {group.routes.map((route, idx) => route.label && renderNavItem(route, idx))}
        </NavExpandable>
      )
    } else {
      return <React.Fragment key={`${group.label}-${groupIndex}`}></React.Fragment>
    }
  }

  const shouldRenderNavItem = (route: AppRouteConfig): boolean => {
    if (!route.label) return false

    return true
  }

  const Navigation = (
    <Nav id="nav-primary" theme="dark">
      <NavList id="nav-list">{routes.map((route, idx) => shouldRenderNavItem(route) && (!route.routes ? renderNavItem(route, idx) : renderNavGroup(route, idx)))}</NavList>
    </Nav>
  )

  const Sidebar = <PageSidebar theme="dark" nav={Navigation} isNavOpen={isMobileView ? isNavOpenMobile : isNavOpen} />

  const pageId = 'primary-app-container'

  const PageSkipToContent = (
    <SkipToContent
      onClick={(event) => {
        event.preventDefault()
        const primaryContentContainer = document.getElementById(pageId)
        primaryContentContainer && primaryContentContainer.focus()
      }}
      href={`#${pageId}`}
    >
      Skip to Content
    </SkipToContent>
  )
  return (
    <Page mainContainerId={pageId} header={Header} sidebar={Sidebar} onPageResize={onPageResize} skipToContent={PageSkipToContent}>
      {children}
    </Page>
  )
}

export { AppLayout }
